import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, LinkButton, Text, WarningCard, WarningIcon } from '@common-fe/common-fe';

import { LINKED_EMPLOYEE_STORAGE_KEY } from '@/common/constants';
import routes from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import { useOrphanModeStore } from '@/modules/core/store';
import { useAuthStore } from '@/modules/user';
import { useGetLinkedAccountsQuery } from '@/modules/user/components/UserDrodpdown/components/OrphanModeSwitcher/queries';
import { useSwitchingModalStore } from '@/modules/user/components/UserDrodpdown/components/OrphanModeSwitcher/store';

const MoneyMovedMessage = () => {
  const { employeeId: defaultEmployeeId } = useAuthStore();
  const { t } = useTranslation();
  const history = useHistory();
  const { handleReset, linkedEmployee: linkedEmployeeFromStore, setLinkedEmployee } = useOrphanModeStore();
  const { setIsModalVisible } = useSwitchingModalStore();
  const { formattedData } = useGetLinkedAccountsQuery();
  const employeeCreatedByOrphan = useMemo(
    () => formattedData.find((item) => item?.isCreatedByOrphan),
    [formattedData]
  );

  const handleSwitchUser = useCallback(() => {
    if (
      employeeCreatedByOrphan &&
      employeeCreatedByOrphan?.employeeId !== linkedEmployeeFromStore?.employeeId &&
      employeeCreatedByOrphan?.employeeId !== defaultEmployeeId
    ) {
      history.push(routes.HOME);
      setLinkedEmployee(employeeCreatedByOrphan);
      localStorage.setItem(LINKED_EMPLOYEE_STORAGE_KEY, JSON.stringify(employeeCreatedByOrphan));
      setIsModalVisible(true);
      return;
    }

    history.push(routes.HOME);
    localStorage.removeItem(LINKED_EMPLOYEE_STORAGE_KEY);
    setIsModalVisible(true);
    handleReset();
  }, [
    defaultEmployeeId,
    handleReset,
    setIsModalVisible,
    history,
    employeeCreatedByOrphan,
    setLinkedEmployee,
    linkedEmployeeFromStore,
  ]);

  return (
    <WarningCard
      icon={<WarningIcon />}
      title={<Text weight="bold">Great news! Your HSA dollars have been moved to your Individual HSA.</Text>}
      testId="money-moved-message"
    >
      <Box margin={{ top: 'spacing8' }}>
        <Text>
          {t(`Full history of the accounts transactions can continue to be accessed here.
          To take action on your account or view your current balance, switch to your `)}
          <LinkButton testId="switcher-to-main-user" onClick={handleSwitchUser} linkInlineMode>
            {t('previous HSA.')}
          </LinkButton>
        </Text>
      </Box>
    </WarningCard>
  );
};

export default MoneyMovedMessage;
